import React from "react";
import SwiperCore, {Mousewheel} from "swiper";
import { Swiper, SwiperSlide } from 'swiper/react';
import Link from "gatsby-link";

SwiperCore.use([Mousewheel]);

const ProjectsList = () => {
  return (
    <ul className="projects-list">
      <Swiper
        slidesPerView="auto"
        direction="vertical"
        mousewheel={true}
        spaceBetween={40}
        preventClicks={false}
        preventClicksPropagation={false}
        updateOnWindowResize={false}
      >
        <SwiperSlide>
          <li className="projects-list__item projects-list__item--active">
            <Link
              className="projects-list__link"
              to={"/the-vision/"}
              activeClassName="projects-list__link--current"
            >
          <span className="projects-list__title-wrapper">
            <span className="projects-list__title">
              <span>The</span>
              <span>Vision</span>
            </span>
          </span>
              <span className="projects-list__count">1</span>
            </Link>
          </li>
        </SwiperSlide>

        <SwiperSlide>
          <li className="projects-list__item projects-list__item--active">
            <Link
              className="projects-list__link"
              to={"/evo-hotel/"}
              activeClassName="projects-list__link--current"
            >
          <span className="projects-list__title-wrapper">
            <span className="projects-list__title">
              <span className="text-lowercase">evo</span>
              <span>Hotel</span>
            </span>
          </span>
              <span className="projects-list__count">2</span>
            </Link>
          </li>
        </SwiperSlide>

        <SwiperSlide>
          <li className="projects-list__item projects-list__item--active">
            <Link
              className="projects-list__link"
              to={"/evo-salt-lake/"}
              activeClassName="projects-list__link--current"
            >
          <span className="projects-list__title-wrapper">
            <span className="projects-list__title">
              <span className="text-lowercase">evo</span>
              <span>Salt Lake</span>
            </span>
          </span>
              <span className="projects-list__count">3</span>
            </Link>
          </li>
        </SwiperSlide>

        <SwiperSlide>
          <li className="projects-list__item projects-list__item--active">
            <Link
              className="projects-list__link"
              to={"/bouldering-project/"}
              activeClassName="projects-list__link--current"
            >
          <span className="projects-list__title-wrapper">
            <span className="projects-list__title">
              <span>Bouldering</span>
              <span>Project</span>
            </span>
          </span>
              <span className="projects-list__count">4</span>
            </Link>
          </li>
        </SwiperSlide>

        <SwiperSlide>
          <li className="projects-list__item projects-list__item--active">
            <Link
              className="projects-list__link"
              to={"/all-together-skatepark/"}
              activeClassName="projects-list__link--current"
            >
          <span className="projects-list__title-wrapper">
            <span className="projects-list__title">
              <span>All Together</span>
              <span>Skatepark</span>
            </span>
          </span>
              <span className="projects-list__count">5</span>
            </Link>
          </li>
        </SwiperSlide>

        <SwiperSlide>
          <li className="projects-list__item projects-list__item--active">
            <Link
              className="projects-list__link"
              to={"/level-nine-sports/"}
              activeClassName="projects-list__link--current"
            >
          <span className="projects-list__title-wrapper">
            <span className="projects-list__title">
              <span>L9</span>
              <span>Sports</span>
            </span>
          </span>
              <span className="projects-list__count">6</span>
            </Link>
          </li>
        </SwiperSlide>

        <SwiperSlide>
          <li className="projects-list__item projects-list__item--active">
            <Link
              className="projects-list__link"
              to={"/market-hall/"}
              activeClassName="projects-list__link--current"
            >
          <span className="projects-list__title-wrapper">
            <span className="projects-list__title">
              <span>Market</span>
              <span>Hall</span>
            </span>
          </span>
              <span className="projects-list__count">7</span>
            </Link>
          </li>
        </SwiperSlide>

        <SwiperSlide>
          <li className="projects-list__item projects-list__item--active">
            <Link
              className="projects-list__link"
              to={"/the-art/"}
              activeClassName="projects-list__link--current"
            >
          <span className="projects-list__title-wrapper">
            <span className="projects-list__title">
              <span>The</span>
              <span>Art</span>
            </span>
          </span>
              <span className="projects-list__count">8</span>
            </Link>
          </li>
        </SwiperSlide>
      </Swiper>
    </ul>
  )
}

export default ProjectsList
